export default __webpack_public_path__ + "static/media/toyota-offer-2.861de085.png";